import ComprasProvider from "./ComprasProvider"
import ComprasMain from "./ComprasMain"

const Compras = () => {
  return (
  <ComprasProvider>
    <ComprasMain />
  </ComprasProvider>    
  )
}

export default Compras
